<script>
import StoreFinderInModal from '@phoenix/mixins/components/store/StoreFinderInModal';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';

export default {
  components: { PhxsgButton },

  mixins: [StoreFinderInModal],
};
</script>

<template>
  <form @submit.prevent="submit">
    <div class="form-group">
      <label :id="`${idPrefix}-search-label`" :for="`${idPrefix}-search`" class="field-label visible-sr">
        {{ $t('Store.storeSelector.searchABoutique') }}
      </label>

      <div class="flex items-center gap-xs">
        <div class="field" style="width: 100%">
          <input
            :id="`${idPrefix}-search`"
            v-model="localKeyword"
            :placeholder="$t('Store.storeSelector.enterCountryCity')"
            type="search"
            class="input field--text"
            name="query"
            autocorrect="off"
            :aria-describedby="`${idPrefix}-search-error ${idPrefix}-search-help`"
          />
        </div>
        <PhxsgButton
          :data-cy="`${idPrefix}-submit`"
          type="submit"
          aria-label="Submit search"
          variant="plain"
          color="primary"
          icon-only
          icon-id="magnifying-glass"
        />
      </div>
    </div>
  </form>
</template>
